// QR Code functionality for cart checkout
(function() {
  let qrCodeInstance = null;

  function isVerticalMode() {
    return document.documentElement.classList.contains('display-vertical');
  }

  function showQRView() {
    console.log('[CartQR] Showing QR view');
    
    if (!isVerticalMode()) {
      console.log('[CartQR] Not in vertical mode, aborting');
      return;
    }

    // Check if we're in cart drawer or cart page
    const isCartPage = document.querySelector('[data-mobile-pay-button][data-cart-page]');
    
    if (isCartPage) {
      // Cart page logic
      const qrView = document.getElementById('qr-payment-view-cart');
      const checkoutButton = document.querySelector('.button--checkout-standard');
      const mobilePayButton = document.querySelector('[data-mobile-pay-button][data-cart-page]');

      if (!qrView) {
        console.log('[CartQR] QR view not found for cart page');
        return;
      }

      // Hide checkout and mobile pay buttons
      if (checkoutButton) checkoutButton.classList.add('hidden');
      if (mobilePayButton) mobilePayButton.classList.add('hidden');

      // Show QR view
      qrView.classList.remove('hidden');

      // Generate QR code for cart page
      generateQRCodeForCartPage();
    } else {
      // Cart drawer logic
      const cartMainContent = document.getElementById('cart-main-content');
      const qrView = document.getElementById('qr-payment-view');

      if (!cartMainContent || !qrView) {
        console.log('[CartQR] Required elements not found:', {
          cartMainContent: !!cartMainContent,
          qrView: !!qrView
        });
        return;
      }

      // Hide cart content
      cartMainContent.classList.add('hidden');

      // Show QR view
      qrView.classList.remove('hidden');

      // Generate QR code
      generateQRCode();
    }
  }

  function showCartView() {
    console.log('[CartQR] Showing cart view');
    
    // Check if we're in cart drawer or cart page
    const isCartPage = document.querySelector('[data-qr-back-button][data-cart-page]');
    
    if (isCartPage) {
      // Cart page logic
      const qrView = document.getElementById('qr-payment-view-cart');
      const checkoutButton = document.querySelector('.button--checkout-standard');
      const mobilePayButton = document.querySelector('[data-mobile-pay-button][data-cart-page]');
      const qrContainer = document.getElementById('qr-code-cart');

      // Show checkout and mobile pay buttons
      if (checkoutButton) checkoutButton.classList.remove('hidden');
      if (mobilePayButton) mobilePayButton.classList.remove('hidden');

      // Hide QR view
      if (qrView) qrView.classList.add('hidden');

      // Clear QR code
      if (qrContainer) qrContainer.innerHTML = '';
    } else {
      // Cart drawer logic
      const cartMainContent = document.getElementById('cart-main-content');
      const qrView = document.getElementById('qr-payment-view');
      const qrContainer = document.getElementById('qr-code');

      if (cartMainContent) {
        cartMainContent.classList.remove('hidden');
      }

      if (qrView) {
        qrView.classList.add('hidden');
      }

      if (qrContainer) {
        qrContainer.innerHTML = '';
      }
    }

    qrCodeInstance = null;
  }

  async function generateQRCodeForCartPage() {
    console.log('[CartQR] Generating QR code for cart page');
    
    const qrContainer = document.getElementById('qr-code-cart');
    
    if (!qrContainer) {
      console.log('[CartQR] QR container not found for cart page');
      return;
    }

    // Show loading state
    qrContainer.innerHTML = '<div class="qr-loading text-sm">Generando código QR...</div>';

    try {
      // Get checkout URL
      const checkoutUrl = await getCheckoutUrl();
      
      if (!checkoutUrl) {
        throw new Error('No se pudo obtener la URL de checkout');
      }

      console.log('[CartQR] Checkout URL:', checkoutUrl);

      // Load QRCode library if not already loaded
      if (typeof QRCode === 'undefined') {
        console.log('[CartQR] Loading QRCode library');
        await loadQRCodeLibrary();
      }

      // Clear loading state
      qrContainer.innerHTML = '';

      // Generate QR code
      qrCodeInstance = new QRCode(qrContainer, {
        text: checkoutUrl,
        width: 256,
        height: 256,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });

      console.log('[CartQR] QR code generated successfully');

    } catch (error) {
      console.error('[CartQR] Error generating QR code:', error);
      qrContainer.innerHTML = '<div class="qr-loading text-sm" style="color: red;">Error al generar el código QR. Por favor, inténtalo de nuevo.</div>';
    }
  }

  async function generateQRCode() {
    console.log('[CartQR] Generating QR code');
    
    const qrContainer = document.getElementById('qr-code');
    
    if (!qrContainer) {
      console.log('[CartQR] QR container not found');
      return;
    }

    // Show loading state
    qrContainer.innerHTML = '<div class="qr-loading text-sm">Generando código QR...</div>';

    try {
      // Get checkout URL
      const checkoutUrl = await getCheckoutUrl();
      
      if (!checkoutUrl) {
        throw new Error('No se pudo obtener la URL de checkout');
      }

      console.log('[CartQR] Checkout URL:', checkoutUrl);

      // Load QRCode library if not already loaded
      if (typeof QRCode === 'undefined') {
        console.log('[CartQR] Loading QRCode library');
        await loadQRCodeLibrary();
      }

      // Clear loading state
      qrContainer.innerHTML = '';

      // Generate QR code
      qrCodeInstance = new QRCode(qrContainer, {
        text: checkoutUrl,
        width: 256,
        height: 256,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });

      console.log('[CartQR] QR code generated successfully');

    } catch (error) {
      console.error('[CartQR] Error generating QR code:', error);
      qrContainer.innerHTML = '<div class="qr-loading text-sm" style="color: red;">Error al generar el código QR. Por favor, inténtalo de nuevo.</div>';
    }
  }

  async function getCheckoutUrl() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      console.log('[CartQR] Cart data:', cart);

      if (!cart || cart.item_count === 0) {
        throw new Error('El carrito está vacío');
      }

      // Use Shopify's clean cart URL format: /cart/VARIANT_ID:QUANTITY,VARIANT_ID:QUANTITY
      // This format is shorter, cleaner, and better recognized by QR scanners
      const items = cart.items.map(item => {
        return `${item.variant_id}:${item.quantity}`;
      }).join(',');

      // Get retail location from localStorage
      const retailLocation = localStorage.getItem('retail-location') || 'Sin especificar';

      // Ensure we have the full URL with protocol for QR code scanning
      const protocol = window.location.protocol; // http: or https:
      const host = window.location.host; // domain.com 
      
      // Create URL with attributes as query parameters
      // Encode brackets properly for QR compatibility
      const params = new URLSearchParams();
      const payLocation = window.RETAILS?.locations?.find(
        loc => loc.metafields?.acronym === retailLocation
      ) || null;
      params.append('attributes[modo_venta]', 'Vertical');
      params.append('attributes[venta_retail]', retailLocation);
      params.append('attributes[venta_codalm]', payLocation?.metafields?.warehouse_code || 'N/A' );
      
      const checkoutUrl = `${protocol}//${host}/cart/${items}?${params.toString()}`;
      
      console.log('[CartQR] Generated checkout URL:', checkoutUrl);
      console.log('[CartQR] Retail location:', retailLocation);
      
      return checkoutUrl;
    } catch (error) {
      console.error('[CartQR] Error getting checkout URL:', error);
      return null;
    }
  }

  function loadQRCodeLibrary() {
    return new Promise((resolve, reject) => {
      if (typeof QRCode !== 'undefined') {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/qrcodejs@1.0.0/qrcode.min.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  // Use event delegation on document body
  document.addEventListener('click', function(e) {
    // Check if clicked element or parent has data-mobile-pay-button
    const mobilePayButton = e.target.closest('[data-mobile-pay-button]');
    if (mobilePayButton && isVerticalMode()) {
      console.log('[CartQR] Mobile pay button clicked via delegation');
      e.preventDefault();
      e.stopPropagation();
      showQRView();
      return;
    }

    // Check if clicked element or parent has data-qr-back-button
    const backButton = e.target.closest('[data-qr-back-button]');
    if (backButton) {
      console.log('[CartQR] Back button clicked via delegation');
      e.preventDefault();
      e.stopPropagation();
      showCartView();
      return;
    }
  });

  console.log('[CartQR] Script loaded and event delegation setup');
  console.log('[CartQR] Is vertical mode:', isVerticalMode());
})();
